/** Package is a separate workspace door, not a permanent inspector tab.
 * The panel's subscription lives only while its window is open. The viewport
 * remains usable for taking portraits. Depends on injected mount and store.
 */
import type { PanelMount } from './panel-registry.js';
import type { AppStore } from '../session/store.js';

export function createPackageDoor(mount: PanelMount, store: AppStore): () => void {
  let dialog: HTMLDialogElement | null = null;
  return () => {
    if (dialog) { dialog.focus(); return; }
    const previous = document.activeElement;
    const window = document.createElement('dialog');
    window.className = 'package-dialog';
    window.setAttribute('aria-label','Package character');
    window.tabIndex = -1;
    const header = document.createElement('header');
    const title = document.createElement('h2');
    title.textContent = 'Package character';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = 'Close';
    close.setAttribute('aria-label','Close Package');
    close.addEventListener('click',()=>window.close());
    header.append(title,close);
    const body = document.createElement('div');
    body.className = 'package-dialog-body';
    window.append(header,body);
    document.body.append(window);
    dialog = window;
    let handle: ReturnType<PanelMount>;
    try { handle = mount(body,store); }
    catch(error) { dialog=null;window.remove();throw error; }
    window.addEventListener('close',()=>{
      handle.dispose(); window.remove(); dialog=null;
      if(previous instanceof HTMLElement && previous.isConnected) previous.focus();
    },{once:true});
    window.addEventListener('keydown',event=>{
      if(event.key==='Escape'){ event.stopPropagation(); window.close(); }
    });
    window.show();
    close.focus();
  };
}
